import { render } from "./authScreen.vue?vue&type=template&id=152ef138&scoped=true"
import script from "./authScreen.vue?vue&type=script&lang=js"
export * from "./authScreen.vue?vue&type=script&lang=js"

import "./authScreen.vue?vue&type=style&index=0&id=152ef138&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152ef138"]])

export default __exports__